<div class="h-screen">
  <div class="flex flex-wrap h-full">
    <div class="relative items-center justify-center hidden w-full lg:flex lg:w-1/2">
      <div class="absolute inset-0 z-10 bg-gray-900 opacity-20"></div>
      <img class="absolute inset-0 z-0 object-cover w-full h-full ml-auto" src="/public/images/login.jpg" />
    </div>
    <div class="w-full flex flex-col justify-between py-6 bg-gray-100 shadow-md lg:py-7 lg:w-1/2">
      <div class="pe-5">
        <!-- <img
          src="/public/images/Logo.svg"
          class="ms-auto self-center w-36 h-9"
        /> -->
        <svg xmlns="http://www.w3.org/2000/svg" class="ms-auto self-center w-36 h-9" width="234" height="60"
          viewBox="0 0 234 60" fill="none">
          <g filter="url(#filter0_d_26211_3574)">
            <path
              d="M43 18.8694C43 18.3311 42.7116 17.8341 42.2442 17.5671L22.7442 6.4242C22.2831 6.16068 21.7169 6.16068 21.2558 6.4242L7.00644 14.5667L10.9319 16.8098L21.6279 10.6978C21.8585 10.566 22.1415 10.566 22.3721 10.6978L37.1824 19.1608L27.8735 24.4801L27.8431 17.7092L23.9075 15.4603L23.9679 28.8834L35.675 35.6422V31.1444L29.8982 27.8093L39.0746 22.5657V22.5936L43 20.3505V18.8694Z"
              fill="#7B8A9F" />
            <path
              d="M43 24.8367L39.0746 27.0798V39.3206C39.0746 39.5897 38.9304 39.8382 38.6967 39.9718L23.9628 48.3912V38.0085L29.6773 41.2405L33.6129 38.9916L22.0002 32.4238L10.3873 38.9917L14.3229 41.2406L20.0373 38.0087V52.8774L21.2558 53.5737C21.7169 53.8372 22.2831 53.8372 22.7442 53.5737L42.2442 42.4308C42.7116 42.1638 43 41.6667 43 41.1285V24.8367Z"
              fill="#7B8A9F" />
            <path
              d="M16.1119 46.1481V50.6343L1.75579 42.4308C1.28843 42.1638 1 41.6667 1 41.1285V18.8694C1 18.3311 1.28843 17.8341 1.75579 17.5671L3.08102 16.8098L7.00644 19.0529L6.98579 19.0647L16.0714 24.2565L16.1007 17.7413L20.0363 15.4924L19.976 28.8834L8.3249 35.6098V31.112L14.2409 27.6966L4.92542 22.3735V39.3206C4.92542 39.5897 5.06964 39.8382 5.30332 39.9718L16.1119 46.1481Z"
              fill="#7B8A9F" />
            <path
              d="M58.7 48V13.15H66.45V48H58.7ZM74.7367 48V22.8H82.2867V25.95C83.3367 23.75 86.1367 22.25 89.5867 22.25C95.8367 22.25 99.2867 26.2 99.2867 32.7V48H91.7367V33.6C91.7367 30.75 90.1867 28.9 87.1867 28.9C84.3367 28.9 82.2867 30.95 82.2867 33.85V48H74.7367ZM105.981 37.5V13.15H113.281V22.8H118.881V29.6H113.281V36.35C113.281 39.9 114.731 41.2 117.981 41.2C118.081 41.2 118.381 41.2 118.381 41.2V48C118.381 48 117.031 48 116.181 48C111.831 48 105.981 46.8 105.981 37.5ZM124.843 36.45V13.15H148.743V20.2H132.593V26.7H147.693V33.6H132.593V36.1C132.593 40.1 135.443 40.95 137.293 40.95H149.093V48H137.043C128.843 48 124.843 43.8 124.843 36.45ZM155.981 48V13.15H163.531V48H155.981ZM170.377 37.85V22.8H177.977V37.2C177.977 40.55 180.077 41.8 182.527 41.8C184.977 41.8 187.077 40.55 187.077 37.2V22.8H194.677V37.85C194.677 45.25 188.977 48.7 182.527 48.7C176.077 48.7 170.377 45.25 170.377 37.85ZM198.939 48L208.489 34.75L199.839 22.8H208.039L212.689 29.4L217.339 22.8H225.539L216.889 34.75L226.439 48H218.289L212.689 40.2L207.089 48H198.939Z"
              fill="#011E41" />
          </g>
          <defs>
            <filter id="filter0_d_26211_3574" x="0" y="-2" width="234" height="68" filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha" />
              <feOffset dx="3" dy="2" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_26211_3574" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_26211_3574" result="shape" />
            </filter>
          </defs>
        </svg>
      </div>
      <div class="w-full max-w-xl mx-auto self-center lg:full">
        <div class="text-3xl text-mdPrimary-500 font-extrabold mb-4">
          Intelux
        </div>

        <div class="w-full max-w-xl mx-auto self-center shadow-lg bg-gray-50 lg:full p-7 rounded-xl">
          <h3 class="mb-4 text-mdPrimary-500 font-extrabold text-xl">Login</h3>
          <form [formGroup]="loginForm" class="p-0 m-0">
            <label for="input-group-1"
              class="block mb-2 text-sm font-medium text-mdPrimary-500 font-extrabold">Email</label>
            <div class="relative mb-6">
              <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                <svg class="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor" viewBox="0 0 20 16">
                  <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
                  <path
                    d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
                </svg>
              </div>
              <input placeholder="Email ID" type="email" formControlName="email" name="email" id="email" type="text"
                id="input-group-1"
                class="bg-gray-50 border border-gray-300 text-mdPrimary-500 text-sm rounded-lg focus:ring-mdPrimary-500 focus:border-mdPrimary-500 block w-full ps-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-mdPrimary-500 dark:focus:border-mdPrimary-500"
                placeholder="abc@electrolux.com" />
            </div>
            <div class="text-red-500 text-xs mt-1" *ngIf="
                loginForm.get('email')?.touched &&
                loginForm.get('email')?.errors
              ">
              <span *ngIf="loginForm.get('email')?.errors?.['required']">Email is required</span>
              <span *ngIf="loginForm.get('email')?.errors?.['email']">Please enter a valid email address</span>
              <span *ngIf="loginForm.get('email')?.errors?.['electroluxEmail']">This is not an Electrolux email ID.
                Please use your &#64;electrolux.com email address</span>
            </div>

            <ng-container *ngIf="isEnableOtp && !isPasswordField">
              <label for="input-group-1"
                class="block mb-2 text-sm font-medium text-mdPrimary-500 font-extrabold">OTP</label>
              <div class="relative mb-6">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                  <svg class="w-5 h-5 text-gray-500" width="24" height="24" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="5" y="11" width="14" height="10" rx="2" />
                    <circle cx="12" cy="16" r="1" />
                    <path d="M8 11v-4a4 4 0 0 1 8 0v4" />
                  </svg>
                </div>
                <input type="text" id="input-group-1" formControlName="otp"
                  class="bg-gray-50 border border-gray-300 text-mdPrimary-500 text-sm rounded-lg focus:ring-mdPrimary-500 focus:border-mdPrimary-500 block w-full ps-10 p-2.5"
                  placeholder="Enter Your OTP" />
              </div>
              <div class="text-red-500 text-xs mt-1" *ngIf="
                  loginForm.get('otp')?.touched && loginForm.get('otp')?.errors
                ">
                <span *ngIf="loginForm.get('otp')?.errors?.['required']">OTP is required</span>
                <span *ngIf="loginForm.get('otp')?.errors?.['maxlength']">OTP must be 6 Digit</span>
              </div>
            </ng-container>
            @if(isPasswordField) {
            <ng-container>
              <label for="input-group-1"
                class="block mb-2 text-sm font-medium text-mdPrimary-500 font-extrabold">Password</label>
              <div class="relative mb-6">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                  <svg class="w-5 h-5 text-gray-500" width="24" height="24" viewBox="0 0 24 24" stroke-width="2"
                    stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="5" y="11" width="14" height="10" rx="2" />
                    <circle cx="12" cy="16" r="1" />
                    <path d="M8 11v-4a4 4 0 0 1 8 0v4" />
                  </svg>
                </div>
                <input type="text" id="input-group-1"
                  class="bg-gray-50 border border-gray-300 text-mdPrimary-500 text-sm rounded-lg focus:ring-mdPrimary-500 focus:border-mdPrimary-500 block w-full ps-10 p-2.5"
                  placeholder="Enter Your Password" />
              </div>
              <div class="text-red-500 text-xs mt-1" *ngIf="
                  loginForm.get('password')?.touched &&
                  loginForm.get('password')?.errors
                ">
                <span *ngIf="loginForm.get('password')?.errors?.['required']">Password is required</span>
              </div>
            </ng-container>
            }
            <button class="w-full px-4 py-4 mt-3 font-medium text-white rounded"
              [class.bg-mdPrimary-500]="!isLoginDisabled" [class.bg-gray-400]="isLoginDisabled"
              [class.cursor-not-allowed]="isLoginDisabled" [disabled]="isLoginDisabled" (click)="generateOtp()"
              type="submit">
              {{ isEnableOtp || isPasswordField ? 'LOGIN' : 'GET OTP' }}
            </button>

            <div class="mt-2 flex justify-between">
              <!-- routerLink="/auth/sign-up" -->
              <!-- <span class="text-sm font-normal text-blacktext"
                >Login as Supervisor/Merchandiser/Trainer<a
                  class="text-sm ml-1 font-normal text-[#007AFF] underline underline-offset-4 cursor-pointer"
                  (click)="loginAdmin('admin')"
                >
                  Login now
                </a></span
              > -->
              <button (click)="reSendOtp()" *ngIf="!disableButton && isEnableOtp && !isPasswordField"
                class="text-sm font-semibold text-mdPrimary-500 underline underline-offset-4">
                Resend OTP
              </button>
              <span *ngIf="disableButton" class="text-sm font-semibold text-gray-500 ml-1">(Wait for {{ timer }}
                sec)</span>
            </div>
          </form>
        </div>
      </div>
      <div></div>
    </div>
  </div>
</div>